import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Chip
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import GamepadIcon from '@material-ui/icons/SportsEsports';
import PersonIcon from '@material-ui/icons/Person';
import TimerIcon from '@material-ui/icons/Timer';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3)
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  matchCard: {
    height: '100%',
    transition: 'transform 0.2s, box-shadow 0.2s',
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[4]
    }
  },
  matchHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  players: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  player: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  vs: {
    color: theme.palette.text.secondary,
    fontWeight: 700,
    fontSize: '1.2rem'
  },
  info: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    flexWrap: 'wrap'
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary
  }
}));

const ActiveMatches = ({ matches = [] }) => {
  const classes = useStyles();
  const history = useHistory();
  
  const handleMatchClick = (matchId) => {
    history.push(`/match/${matchId}/details`);
  };
  
  if (matches.length === 0) {
    return null; // Don't show if no active matches
  }
  
  return (
    <Paper className={classes.paper}>
      <Typography variant="h6" className={classes.title}>
        <GamepadIcon />
        Active Matches ({matches.length})
      </Typography>
      
      <Grid container spacing={2}>
        {matches.map((match) => (
          <Grid item xs={12} sm={6} md={4} key={match.matchId}>
            <Card 
              className={classes.matchCard}
              onClick={() => handleMatchClick(match.matchId)}
            >
              <CardContent>
                <Box className={classes.matchHeader}>
                  <Chip 
                    label={match.status} 
                    color="success" 
                    size="small" 
                  />
                  <Typography 
                    variant="caption" 
                    color="textSecondary"
                    style={{ fontFamily: 'monospace' }}
                  >
                    {match.matchId.substring(0, 8)}
                  </Typography>
                </Box>
                
                <Box className={classes.players}>
                  <Box className={classes.player}>
                    <PersonIcon fontSize="small" color="primary" />
                    <Typography variant="body2" noWrap>
                      {match.player1}
                    </Typography>
                  </Box>
                  
                  <Typography className={classes.vs}>VS</Typography>
                  
                  <Box className={classes.player}>
                    <PersonIcon fontSize="small" color="secondary" />
                    <Typography variant="body2" noWrap>
                      {match.player2}
                    </Typography>
                  </Box>
                </Box>
                
                <Box className={classes.info}>
                  <Box className={classes.infoItem}>
                    <GamepadIcon fontSize="small" />
                    <Typography variant="caption">{match.map}</Typography>
                  </Box>
                  
                  {match.duration && (
                    <Box className={classes.infoItem}>
                      <TimerIcon fontSize="small" />
                      <Typography variant="caption">
                        {Math.floor(match.duration / 60)}m
                      </Typography>
                    </Box>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default ActiveMatches;

